import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	AppAuctionFilter,
	AppAuctionPages,
	AppAuctionTypes,
} from '../../components/AppAuction';

interface IAuctionSlice {
	activeAuctionFilter: AppAuctionFilter;
	activeAuctionPage: AppAuctionPages;
	activeAuctionCarModelFilter: string;
	activeAuctionRealtyTypeFilter: string;
	activeAuctionClothesTypeFilter: string;
	activeAuctionBussinessTypeFilter: string;
	itemAuctionPageVisible: boolean;
	categorySelectVisible: boolean;
	itemSelectVisible: boolean;
	createVisible: boolean;
	doneVisible: boolean;
	createCategory: AppAuctionTypes;
	itemType: AppAuctionTypes;
}

const initialState: IAuctionSlice = {
	activeAuctionFilter: AppAuctionFilter.Main,
	activeAuctionPage: AppAuctionPages.Main,
	activeAuctionCarModelFilter: '',
	activeAuctionRealtyTypeFilter: '',
	activeAuctionClothesTypeFilter: '',
	activeAuctionBussinessTypeFilter: '',
	itemAuctionPageVisible: false,
	categorySelectVisible: false,
	itemSelectVisible: false,
	createVisible: false,
	doneVisible: false,
	createCategory: AppAuctionTypes.Vehicle,
	itemType: AppAuctionTypes.Vehicle,
};

const auctionSlice = createSlice({
	name: 'auction',
	initialState,
	reducers: {
		setAuctionActiveFilter: (state, action) => {
			state.activeAuctionFilter = action.payload;
		},
		setAuctionActivePage: (state, action) => {
			state.activeAuctionPage = action.payload;
		},
		setAuctionModelFilter: (
			state,
			action: PayloadAction<{ type: AppAuctionTypes; value: string }>,
		) => {
			if (action.payload.type === AppAuctionTypes.Vehicle) {
				state.activeAuctionCarModelFilter = action.payload.value;
				state.activeAuctionRealtyTypeFilter = '';
				state.activeAuctionClothesTypeFilter = '';
				state.activeAuctionBussinessTypeFilter = '';
			}
			if (action.payload.type === AppAuctionTypes.Realty) {
				state.activeAuctionRealtyTypeFilter = action.payload.value;
				state.activeAuctionCarModelFilter = '';
				state.activeAuctionClothesTypeFilter = '';
				state.activeAuctionBussinessTypeFilter = '';
			}
			if (action.payload.type === AppAuctionTypes.Clothes) {
				state.activeAuctionClothesTypeFilter = action.payload.value;
				state.activeAuctionCarModelFilter = '';
				state.activeAuctionRealtyTypeFilter = '';
				state.activeAuctionBussinessTypeFilter = '';
			}
			if (action.payload.type === AppAuctionTypes.Bussiness) {
				state.activeAuctionBussinessTypeFilter = action.payload.value;
				state.activeAuctionCarModelFilter = '';
				state.activeAuctionRealtyTypeFilter = '';
				state.activeAuctionClothesTypeFilter = '';
			}
		},
		setItemAuctionPageVisible: (state, action) => {
			state.itemAuctionPageVisible = action.payload;
		},
		setAuctionCategorySelectVisible: (state, action) => {
			state.categorySelectVisible = action.payload;
		},
		setAuctionItemSelectVisible: (state, action) => {
			state.itemSelectVisible = action.payload;
		},
		setAuctionCreateVisible: (state, action) => {
			state.createVisible = action.payload;
		},
		setAuctionDoneVisible: (state, action) => {
			state.doneVisible = action.payload;
		},
		setAuctionCreateCategory: (state, action) => {
			state.createCategory = action.payload;
		},
		setAuctionItemType: (state, action) => {
			state.itemType = action.payload;
		},
		resetAuctionSlice: () => ({ ...initialState }),
	},
});

export const {
	setAuctionActiveFilter,
	setAuctionActivePage,
	setAuctionModelFilter,
	setItemAuctionPageVisible,
	resetAuctionSlice,
	setAuctionCategorySelectVisible,
	setAuctionItemSelectVisible,
	setAuctionCreateVisible,
	setAuctionCreateCategory,
	setAuctionItemType,
	setAuctionDoneVisible,
} = auctionSlice.actions;

export default auctionSlice.reducer;
